export const PS_COUNTRY_SELECTION_LOADER = {
  desktop: `<div class="ps-country-selection-root" style="display: flex; min-height: 100vh; justify-content: center; align-items: center;">
  <main class="cui-container cui-grid" style="display: flex; flex-direction: column; align-items: center;">
    <div class="cui-skeleton-heading -size--extra-large -resolution--desktop" style="margin-bottom: 24px;">
      <div class="cui-skeleton-heading__content" style="width:min(300px, 100%)">
        <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
        <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
        <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
      </div>
    </div>
    <div class="country-selection" data-aid="select_region_list" style="flex: 1 1 auto; width: 100%;">
      <div class="cui-row">
        <div class="cui-col-md-2 cui-col-sm-12">
          <div class="cui-skeleton-heading -size--extra-large -resolution--desktop" style="margin-bottom: 24px;">
            <div class="cui-skeleton-heading__content" style="width:min(300px, 100%)">
              <div class="cui-skeleton__item cui-skeleton-heading__title" style="width: 180px;"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
            </div>
          </div>
        </div>

        <div class="cui-col-md-2 cui-col-sm-12">
          <div class="cui-skeleton-heading -size--extra-large -resolution--desktop" style="margin-bottom: 24px;">
            <div class="cui-skeleton-heading__content" style="width:min(300px, 100%)">
              <div class="cui-skeleton__item cui-skeleton-heading__title" style="width: 180px;"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
            </div>
          </div>
        </div>

        <div class="cui-col-md-2 cui-col-sm-12">
          <div class="cui-skeleton-heading -size--extra-large -resolution--desktop" style="margin-bottom: 24px;">
            <div class="cui-skeleton-heading__content" style="width:min(300px, 100%)">
              <div class="cui-skeleton__item cui-skeleton-heading__title" style="width: 180px;"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
            </div>
          </div>
        </div>

        <div class="cui-col-md-2 cui-col-sm-12">
          <div class="cui-skeleton-heading -size--extra-large -resolution--desktop" style="margin-bottom: 24px;">
            <div class="cui-skeleton-heading__content" style="width:min(300px, 100%)">
              <div class="cui-skeleton__item cui-skeleton-heading__title" style="width: 180px;"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
              <div class="cui-skeleton__item cui-skeleton__description ng-star-inserted"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>`
};
